const SelectComponent = ({ data, value, onChange })  => {
  return (
    <select
        className="form-select border-none w-100px"
        style={{width: '120px'}}
        aria-label="select keys"
        value={value}
        onChange={(e) => {
            onChange(e.target.value);
        }}
    >
        {
            data.map((value, index) => {
            return (
                <option key={index} value={value.value}>
                    {value.label}
                </option>
            );
            })
        }
    </select>
  )
}

export default SelectComponent;